<template>
    <div class="customers-learning">
        
        <content-switch
        :items="switchItems"
        :selectedItem="selectedItem"
        :counts="counts"
        @selectItem="handleSelectItem($event)" />
        
        <claims-table v-show="selectedItem === 'claims'" @finishedLoading="updateCount('claims', $event)"/>
        
    </div>
</template>

<script>

export default {
    data () {
        return {
            selectedItem: 'claims',
            counts: {
                claims: null
            },
            switchItems: [
                {
                    name: 'Afsluttede reklamationer',
                    slug: 'claims'
                }
            ]
        }
    },
    methods: {
        updateCount (slug, event) {
            this.counts[slug] = event
        },
        handleSelectItem (item) {
            this.selectedItem = item
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            })
        }
    },
    mounted () {
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab
        }
        this.$store.state.view = 'operations'
    },
    components: {
        'claims-table': require('./operations/claims.vue')
    }
}
</script>



// WEBPACK FOOTER //
// operations.vue?3d67b5b5